import { render, staticRenderFns } from "./PopupService.vue?vue&type=template&id=ac010c16"
import script from "./PopupService.vue?vue&type=script&lang=js"
export * from "./PopupService.vue?vue&type=script&lang=js"
import style0 from "./PopupService.vue?vue&type=style&index=0&id=ac010c16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports